import { Form, Upload, message } from 'antd';
import { useState } from 'react';
// import './MarketingFileUpload.css';

export const MarketingFileUpload = ({ disabled }) => {
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [error, setErrors] = useState([]);

  const getBase64 = (file, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(file);
  };

  const beforeUpload = (file) => {
    const newErrors = [];

    const allowedFormats = ['.doc', '.docx', '.pdf', '.jpeg', '.jpg', '.png'];
    const fileExtension = file.name.split('.').pop().toLowerCase();
    const isAllowedFormat = allowedFormats.includes(`.${fileExtension}`);
    if (!isAllowedFormat) {
      newErrors.push('Можна завантажити тільки файли!');
    }
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      newErrors.push('Розмір файлу не має перевищувати 10 МБ!');
    }
    setErrors(newErrors);
    return isAllowedFormat && isLt10M;
  };

  const handleChange = (info) => {
    setFileList(info.fileList);

    if (info.file.status === 'uploading') {
      setLoading(true);
      setErrors([]);
      return;
    }
    if (info.file.status === 'done') {
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        // Можно сохранить URL для предварительного просмотра, если нужно
      });
    } else if (info.file.status === 'error') {
      setLoading(false);
      message.error('Помилка при загрузці файлу');
      setErrors(['Ошибка загрузки файла.']);
      setFileList([]);
    }
  };

  const customRequest = ({ file, onSuccess, onError }) => {
    // Имитация успешной загрузки для клиентской стороны
    setTimeout(() => {
      onSuccess('ok', file);
    }, 0);
  };

  const onRemove = (file) => {
    // Удаление файла из списка
    setFileList([]);
    setErrors([]);
    return true;
  };

  return (
    <Form.Item
      name="attach_file_1"
      label="Завантажити файл (jpg, png, pdf, doc)"
      validateStatus={error.length > 0 ? 'error' : ''}
      help={error.join(' ')}
    >
      <Upload
        disabled={disabled}
        beforeUpload={beforeUpload}
        onChange={handleChange}
        customRequest={customRequest}
        onRemove={onRemove}
        fileList={fileList}
        className="commodity-form__upload"
        maxCount={1}
        showUploadList={{
          showRemoveIcon: true, // Показывать кнопку удаления
        }}
      >
        {fileList.length === 0 && 'Оберіть файл'}
      </Upload>
    </Form.Item>
  );
};
